import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error']),
};

const defaultProps = {
  children: null,
  className: '',
  type: 'success',
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: 8,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.success.main,
    borderColor: theme.palette.success.dark,
  },
  error: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
    borderColor: theme.palette.error.dark,
  },
}));

const Alert = (props) => {
  const classes = useStyles();
  const {
    className, children, type,
  } = props;
  return (
    <Paper className={clsx(classes.root, className, { [classes.error]: type === 'error' })}>
      <Typography color="inherit" variant="caption">
        {children}
      </Typography>
    </Paper>
  );
};

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

export default Alert;
